import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import aboutEnglish from '../Data/English/about.json';
import aboutArabic from '../Data/Arabic/about.json';
import constEnglish from '../Data/English/constitution.json';
import constArabic from '../Data/Arabic/constitution.json'
i18n
.use(initReactI18next)// pass i18n to react
.init({
    resources:{
        en: {
            translation: aboutEnglish
        },
        ar:{
            translation: aboutArabic
        }
    },
    lng:'en', //this is the default language
    fallbackLng:'en', //if no translation, return to english
    interpolation:{
        escapeValue: false, // react already safes from xss
    }
});
export default i18n;